import Seo from '@/components/shared/Seo';
import TradeController from '@/components/trade/TradeController';
export default function TradePage() {
  return <>
      <Seo title='Trade • Genius Terminal • Trade Crypto Like a Genius' data-sentry-element="Seo" data-sentry-source-file="index.tsx" />
      <TradeController data-sentry-element="TradeController" data-sentry-source-file="index.tsx" />
    </>;
}